
import gsap from 'gsap'

export default {
  name: 'Overlay',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tl: undefined,
  }),
  watch: {
    open: {
      async handler(val) {
        if (val) {
          this.tl.totalDuration(this.getDuration())
          await this.tl.play()
          this.$emit('open')
        } else {
          this.tl.totalDuration(this.getDuration())
          await this.tl.reverse()

          this.$emit('close')
        }
      },
    },
  },
  mounted() {
    const tl = gsap
      .timeline({
        paused: true,
        onReverseComplete: () => gsap.set('body', { clearProps: 'all' }),
      })
      .set('body', { overflow: 'hidden' })
      .set(this.$refs.content, { autoAlpha: 1 })
      .from(this.$refs.background, { opacity: 0.75, translateY: '-100%' })
      .from(this.$refs.wrap, { autoAlpha: 0, y: '50px' }, '-=.4')

    this.tl = tl
  },
  methods: {
    getDuration() {
      let duration = 0.6
      if (window.matchMedia('(min-width: 750px)').matches) {
        duration = 0.8
      }
      if (window.matchMedia('(min-width: 1100px)').matches) {
        duration = 1
      }
      if (window.matchMedia('(min-width: 1750px)').matches) {
        duration = 1.2
      }
      return duration
    },
  },
}
